import scanCode from './scanCode.vue'
export default scanCode
